<template>
    <div>
        <div class="modal fade overflow-hidden" id="uploadAvatarModal" tabindex="-1" aria-labelledby="uploadAvatarModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content overflow-hidden border-0 p-0">
                    <div class="modal-body d-flex p-0">
                        <div class="avatar-preview">
                            <div class="d-flex flex-column align-items-center">
                                <h3 class="title">{{ $t('student_profile') }}</h3>
                                <div class="avatar" v-if="tab == 'custom'">
                                    <div class="avatar-wrapper" id="customAvatar">
                                        <img ref="avatar_url" class="w-100 img-fluid" :style="{ 'z-index': layer.order }" :src="layer.url" v-for="layer in customAvatar">
                                    </div>
                                </div>
                                <div class="avatar" v-else>
                                    <div class="avatar-wrapper">
                                        <img ref="avatar_url" class="w-100 img-fluid" :src="user_update_info.avatar_url">
                                    </div>
                                    <img ref="emoticon_url" class="emoticon" :src="user_update_info.emoji_url" alt="" v-if="user_update_info.emoji_url">
                                </div>
                                <div class="control">
                                    <button class="ito-btn ito-btn-secondary" @click="saveCustomAvatar()" :disabled="!is_custom_avatar_updated" v-if="tab == 'custom'">
                                        {{ $t('save') }}
                                    </button>
                                    <button class="ito-btn ito-btn-secondary" @click="saveUpdate()" :disabled="user_update_info.avatar_id == user_info.avatar_id && user_update_info.emoji_id == user_info.emoji_id" v-else>
                                        {{ $t('save') }}
                                    </button>
                                    <button class="ito-btn ito-btn-outline-primary" data-bs-dismiss="modal" aria-label="Close">
                                        {{ $t('cancel') }}</button>
                                </div>
                            </div>
                        </div>

                        <div class="avatar-edit">
                            <ul id="main-nav" class="nav nav-tabs" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="avatar-tab" @click="tab = 'avatar'" data-bs-toggle="tab" data-bs-target="#avatar" type="button" role="tab" aria-controls="avatar" aria-selected="true">
                                        {{ $t('avatar') }}
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="custom-avatar-tab" @click="tab = 'custom'" data-bs-toggle="tab" data-bs-target="#custom-avatar" type="button" role="tab" aria-controls="home" aria-selected="false">
                                        {{ $t('custom_avatar') }}
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="emoticon-tab" @click="tab = 'emoticon'" data-bs-toggle="tab" data-bs-target="#emoticon" type="button" role="tab" aria-controls="emoticon" aria-selected="false">
                                        {{ $t('emoticon') }}
                                    </button>
                                </li>
                            </ul>
                            <div id="main-tab-content" class="tab-content">
                                <div class="tab-pane fade show active" id="avatar" role="tabpanel" aria-labelledby="avatar-tab">
                                    <div class="nano">
                                        <div class="nano-content">
                                            <div class="avatar-list py-3">
                                                <!--                                                <div class="avatar-item">
                                                    <label class="avatar-item-upload" for="uploadAvatar">
                                                        <img src="/themes/ito/images/avatar-0.svg?v=2" alt="">
                                                    </label>
                                                    <input type="file" id="uploadAvatar" class="d-none" name="avatar" accept="image/*" @change="uploadAvatar" />
                                                </div>-->
                                                <div class="avatar-item" v-for="avatar in avatars">
                                                    <div class="avatar-item-wrapper" :class="{ 'active': user_update_info.avatar_id == avatar.id, 'current': avatar.id == user_info.avatar_id }" @click="selectItem(tab, avatar)">
                                                        <img :src="avatar.url" alt="" v-if="avatar.url">
                                                        <div class="spinner-border spinner-border-sm" role="status" v-else></div>
                                                    </div>
                                                    <div class="locked" v-if="avatar.status == 1"></div>
                                                    <button class="ito-btn ito-btn-sm ito-btn-primary" :disabled="avatar.status == 1" v-if="avatar.price > 0">{{ avatar.price }} <i class="ito-icon-gem"></i></button>
                                                    <button class="ito-btn ito-btn-sm ito-btn-success" v-if="avatar.id == user_info.avatar_id && avatar.price <= 0"><i class="ito-icon-checked-white-nb"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="custom-avatar" role="tabpanel" aria-labelledby="custom-avatar-tab">
                                    <div class="custom-avatar-tabs">
                                        <ul id="custom-avatar-nav" class="nav nav-tabs d-flex flex-nowrap" role="tablist">
                                            <template v-for="(category, index) in objects">
                                                <li class="nav-item" role="presentation" v-if="category.linked_object_id == 0">
                                                    <button class="nav-link text-capitalize" :class="{ active: index == 0 }" data-bs-toggle="tab" :data-bs-target="'#tab-' + category.id" type="button" role="tab" aria-controls="home" aria-selected="true">
                                                        {{ category.name }}
                                                    </button>
                                                </li>
                                            </template>
                                        </ul>
                                        <div id="custom-avatar-tab-content" class="tab-content">
                                            <template v-for="(category, index) in objects">
                                                <div class="tab-pane fade" :class="{ active: index == 0, show: index == 0 }" :id="'tab-' + category.id" role="tabpanel" aria-labelledby="home-tab" v-if="category.linked_object_id == 0">
                                                    <div class="avatar-list py-3" v-if="category.shape_details">
                                                        <div class="avatar-item" v-if="category.is_required != 1">
                                                            <div class="avatar-item-wrapper" :class="{ active: isSelectedShape(category, 'no_shape'), current: isCurrentShape(category, 'no_shape') }" @click="removeShape(category)">
                                                                <img src="/themes/ito/images/open-house/no_shape.png" :alt="category.name + '-no-shape'">
                                                            </div>
                                                            <button class="ito-btn ito-btn-sm ito-btn-success" v-if="isCurrentShape(category, 'no_shape')"><i class="ito-icon-checked-white-nb"></i></button>
                                                        </div>
                                                        <template v-for="shape in category.shape_details">
                                                            <div class="avatar-item">
                                                                <div class="avatar-item-wrapper" :class="{ active: isSelectedShape(category, shape), current: isCurrentShape(category, shape) }" @click="selectShape(category, shape)">
                                                                    <img :src="shape.thumbnail_url ? shape.thumbnail_url : shape.image_url" :alt="category.name + '-' + shape.id" v-if="shape.image_url || shape.thumbnail_url">
                                                                    <div class="spinner-border spinner-border-sm" role="status" v-else></div>
                                                                </div>
                                                                <div class="locked" v-if="shape.pacing_status == 1"></div>
                                                                <button class="ito-btn ito-btn-sm ito-btn-primary" :disabled="shape.pacing_status == 1" v-if="shape.status == 'inactivated'" @click="buyShape(category, shape)">{{ shape.price }} <i
                                                                        class="ito-icon-gem"></i></button>
                                                                <button class="ito-btn ito-btn-sm ito-btn-success" v-if="isCurrentShape(category, shape) && shape.status == 'activated'"><i class="ito-icon-checked-white-nb"></i></button>
                                                            </div>
                                                        </template>
                                                    </div>
                                                    <template v-if="category.colors">
                                                        <ul id="colors-nav" class="nav nav-tabs d-flex" role="tablist">
                                                            <li class="nav-item" role="presentation" v-for="(color, index2) in category.colors">
                                                                <button class="nav-link text-capitalize" :class="{ active: index2 == 0 }" data-bs-toggle="tab" :data-bs-target="'#color-' + category.id + '-' + color.id" type="button" role="tab"
                                                                    aria-controls="home" aria-selected="true">
                                                                    <div :style="{ 'background-color': '#' + color.code }" :title="color.name"></div>
                                                                </button>
                                                            </li>
                                                        </ul>
                                                        <div id="colors-tab-content" class="tab-content">
                                                            <template v-for="(color, index2) in category.colors">
                                                                <div class="tab-pane fade" :class="{ active: index2 == 0, show: index2 == 0 }" :id="'color-' + category.id + '-' + color.id" role="tabpanel" aria-labelledby="home-tab">
                                                                    <div class="avatar-list py-3">
                                                                        <div class="avatar-item" v-if="category.is_required != 1">
                                                                            <div class="avatar-item-wrapper" :class="{ active: isSelectedShape(category, 'no_shape'), current: isCurrentShape(category, 'no_shape') }" @click="removeShape(category)">
                                                                                <img src="/themes/ito/images/open-house/no_shape.png" :alt="category.name + '-no-shape'">
                                                                            </div>
                                                                            <button class="ito-btn ito-btn-sm ito-btn-success" v-if="isCurrentShape(category, 'no_shape')"><i class=" ito-icon-checked-white-nb"></i></button>
                                                                        </div>
                                                                        <template v-for="shape in color.shape_details">
                                                                            <div class="avatar-item">
                                                                                <div class="avatar-item-wrapper" :class="{ active: isSelectedShape(category, shape), current: isCurrentShape(category, shape) }" @click="selectShape(category, shape)">
                                                                                    <img :src="shape.thumbnail_url ? shape.thumbnail_url : shape.image_url" :alt="category.name + '-' + shape.id" v-if="shape.image_url || shape.thumbnail_url">
                                                                                    <div class="spinner-border spinner-border-sm" role="status" v-else></div>
                                                                                </div>
                                                                                <div class="locked" v-if="shape.pacing_status == 1"></div>
                                                                                <button class="ito-btn ito-btn-sm ito-btn-primary" :disabled="shape.pacing_status == 1" v-if="shape.status == 'inactivated'" @click="buyShape(category, shape)">{{ shape.price }}
                                                                                    <i class="ito-icon-gem"></i></button>
                                                                                <button class="ito-btn ito-btn-sm ito-btn-success" v-if="isCurrentShape(category, shape) && shape.status == 'activated'"><i class="
                                                                                    ito-icon-checked-white-nb"></i></button>
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="emoticon" role="tabpanel" aria-labelledby="emoticon-tab">
                                    <div class="avatar-list py-3">
                                        <div class="col-2 avatar-item" v-for="emoticon in emoticons">
                                            <div class="avatar-item-wrapper" :class="{ 'active': user_update_info.emoji_id == emoticon.id, 'current': emoticon.id == user_info.emoji_id }" @click="selectItem(tab, emoticon)">
                                                <img :src="emoticon.url" alt="">
                                            </div>
                                            <div class="locked" v-if="emoticon.status == 1"></div>
                                            <button class="ito-btn ito-btn-sm ito-btn-primary" :disabled="emoticon.status == 1" v-if="emoticon.price > 0">{{ emoticon.price }} <i class="ito-icon-gem"></i></button>
                                            <button class="ito-btn ito-btn-sm ito-btn-success" v-if="emoticon.id == user_info.emoji_id"><i class="ito-icon-checked-white-nb"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="original" class="avatar_container">
                <img class="img-fluid" :style="{ 'z-index': layer.order }" :src="layer.url" v-for="layer in customAvatar">
            </div>
        </div>

        <div class="modal fade" id="cropAvatarModal" tabindex="-1" aria-labelledby="cropAvatarModal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog">
                <div class="modal-content pb-2">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">{{ $t('edit_image') }}</h3>

                    <div class="modal-body">
                        <div class="image-crop-content">
                            <img id="image-crop" :src="avatar_crop_data">
                        </div>
                        <div class="d-flex justify-content-center mt-3">
                            <button class="ito-btn ito-btn-primary" @click="cropSave">{{ $t('save') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="changeAvatarSuccessModal" tabindex="-1" aria-labelledby="changeAvatarSuccessModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">{{ $t('has_success') }}</h3>
                    <div class="modal-body text-center" style="padding: 0">
                        <div class="message">{{ $t('avatar_has_been_updated_successfully') }}</div>

                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="errorModalProfile" tabindex="-1" aria-labelledby="errorModalProfile" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" style="width: 550px;">
                <div class="modal-content">
                    <div class="modal-header border-0">
                        <div class="close-popup" data-bs-dismiss="modal"></div>
                        <h3 class="popup-title">{{ $t(errors.title) }}</h3>
                    </div>

                    <div class="modal-body text-center">
                        <img src="/themes/ito/images/image01/icon-error.svg" alt="">
                        <div class="message mt-3">{{ $t(errors.message) }}</div>
                    </div>
                    <div class="modal-footer border-0 d-flex justify-content-center">
                        <button class="ito-btn ito-btn-primary" data-bs-target="#uploadAvatarModal" data-bs-toggle="modal" data-bs-dismiss="modal">{{ $t('back') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="confirmBuyItem" tabindex="-1" aria-labelledby="errorModalProfile" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content p-0" style="width: 388px;">
                    <div class="modal-header border-0">
                        <div class="close-popup" data-bs-dismiss="modal"></div>
                        <h3 class="popup-title">{{ $t('buy_item') }}</h3>
                    </div>
                    <div class="modal-body text-center">
                        <div class="message " v-html="$t('gems_to_buy', { gem: selectedShape.price })"></div>
                    </div>
                    <div class="modal-footer border-0 d-flex  gap-3 justify-content-center">
                        <button class="ito-btn ito-btn-outline-primary" data-bs-target="#uploadAvatarModal" data-bs-toggle="modal" data-bs-dismiss="modal">{{ $t('no') }} </button>
                        <button class="ito-btn ito-btn-primary" data-bs-dismiss="modal" @click="buyItem()">{{ $t('yes') }} </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { getAvatars, updateAvatar, getCustomAvatars, buyCustomAvatar, saveCustomAvatar } from '../models/profile';
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';
import { domToDataUrl } from 'modern-screenshot'

export default {
    name: "AvatarEdit",

    data() {
        return {
            tab: 'avatar',
            avatars: [],
            curentCustomavatar: [],
            customAvatar: {},
            avatar_crop_data: '',
            emoticons: [],
            user_update_info: {
                emoji_id: this.$store.state.user_info.emoji_id,
                emoji_url: this.$store.state.user_info.emoji_url,
                avatar_id: this.$store.state.user_info.avatar_id,
                avatar_url: this.$store.state.user_info.avatar_url,
                change_avatar: undefined,
                change_emoji: undefined,

                avatar_img: undefined,
                type: undefined,
                extension_file: undefined
            },
            objects: [],
            selectedShape: {},
            selectedCategory: {},
            is_custom_avatar_updated: false,
            errors: {
                title: 'has_error',
                message: '',
            },

        };
    },
    watch: {
        customAvatar: {
            handler: function (val, oldVal) {
                var result = false;
                var arr1 = {}
                if (this.curentCustomavatar.length <= 0) {
                    result = true;
                } else {
                    this.curentCustomavatar.forEach((item) => {
                        arr1[item.object_id] = {
                            id: '',
                            shape_id: item.shape_id,
                            shape_detail_id: item.shape_detail_id,
                            object_id: item.object_id,
                            color_id: item.color_id,
                            order: item.order,
                            url: item.image_url,
                            status: undefined
                        }
                    })
                    if (JSON.stringify(arr1) != JSON.stringify(val)) {
                        result = true;
                    }
                }
                this.is_custom_avatar_updated = result;
            },
            deep: true,
        }
    },

    computed: {
        user_info() {
            return this.$store.state.user_info
        },
    },

    created() {
        this.fetch();
    },
    mounted() {
        this.$nextTick(function () {
            const that = this;
            $('#cropAvatarModal').on('shown.bs.modal', function () {
                that.cropper = new Cropper(
                    document.getElementById('image-crop'), {
                    aspectRatio: 1,
                    crop(event) {
                    }
                });
            });
            $('#cropAvatarModal').on('hiden.bs.modal', function () {
                that.cropper.destroy();
            })
        });
    },

    updated() {
        const slider = document.querySelector('#custom-avatar-nav');
        let isDown = false;
        let startX;
        let startY;
        let scrollLeft;
        let scrollTop;
        if (slider) {
            slider.addEventListener("wheel", (e) => {
                e.preventDefault();
                const walk = e.deltaY * 0.1;
                slider.scrollLeft += walk;
            })
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                startY = e.pageY - slider.offsetTop;
                scrollLeft = slider.scrollLeft;
                scrollTop = slider.scrollTop;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('active');
            });

            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const y = e.pageY - slider.offsetTop;
                const walk = (x - startX) * 1;
                const walktop = (y - startY) * 1;
                slider.scrollLeft = scrollLeft - walk;
                slider.scrollTop = scrollTop - walktop;
            });
        }
    },

    methods: {
        fetch() {
            this.getCustomAvatar();
            this.getAvatar();
        },

        getAvatar() {
            const that = this;
            axios.all([getAvatars()]).then(axios.spread((response) => {
                if (response.data.code != 0) {
                    return;
                }
                const items = response.data.results.items || [];
                var avatars = [], emoticons = [];
                items.forEach(function (item) {
                    if (item.type == 0) {
                        avatars.push(item)
                    }
                    if (item.type == 1) {
                        emoticons.push(item)
                    }
                });
                that.avatars = avatars;
                that.emoticons = emoticons;
            }));
        },

        selectItem(type, item) {
            if (type == 'avatar') {
                this.user_update_info.avatar_url = item.url;
                this.user_update_info.avatar_id = item.id;
                if (this.user_info.avatar_id != item.id) {
                    this.user_update_info.change_avatar = 1;
                }
                else {
                    delete this.user_update_info.change_avatar
                }
            }
            else if (type == 'emoticon') {
                this.user_update_info.emoji_url = item.url;
                this.user_update_info.emoji_id = item.id;
                if (this.user_info.emoji_id != item.id) {
                    this.user_update_info.change_emoji = 1;
                }
                else {
                    delete this.user_update_info.change_emoji
                }
            }
        },

        uploadAvatar(e) {
            switch (e.target.name) {
                case 'avatar':
                    const image = e.target.files[0];
                    if (image) {
                        if (image.size / (1024 * 1000) >= 10) {
                            this.showError('Kích thước ảnh tối đa cho phép tải lên là 10Mb. Vui lòng chọn ảnh khác.')
                            break;
                        }
                        if (/\.(jpe?g|png|gif)$/i.test(image.name)) {
                            const reader = new FileReader();
                            reader.readAsDataURL(image);
                            reader.onload = e => {
                                this.avatar_crop_data = e.target.result;
                                $('.modal').modal('hide');
                                $('#cropAvatarModal').modal('show');
                            };
                        } else {
                            this.showError('Định dạng ảnh không hợp lệ, vui lòng chọn ảnh khác.')
                            break;
                        }
                    }
                    break;

                default:
                    break;
            }

        },

        cropSave() {
            const that = this;
            that.$store.commit("setLoading", true);
            if (that.cropper) {
                const croppedImageDataURL = that.cropper.getCroppedCanvas().toDataURL("image/png");
                that.user_update_info.change_avatar = 1;
                updateAvatar({
                    avatar_id: -1,
                    avatar_img: croppedImageDataURL,
                    extension_file: 'png',
                }).then((response) => {
                    that.$store.commit("setLoading", false);
                    $('.modal').modal('hide');
                    $('#changeAvatarSuccessModal').modal('show');
                    that.cropper.destroy();
                    if (response.data.code != 0) {
                        that.showError(response.data.msg)
                        return;
                    }
                    that.user_info.avatar_id = response.data.results.avatar_id;
                    that.user_info.avatar_url = response.data.results.avatar_url ? response.data.results.avatar_url : "/themes/ito/images/avatar-default-orange.svg";
                    that.user_info.emoji_id = response.data.results.emoji_id;
                    that.user_info.emoji_url = response.data.results.emoji_url;
                    that.user_update_info.avatar_id = response.data.results.avatar_id;
                    that.user_update_info.avatar_url = response.data.results.avatar_url ? response.data.results.avatar_url : "/themes/ito/images/avatar-default-orange.svg";
                    that.user_update_info.emoji_id = response.data.results.emoji_id;
                    that.user_update_info.emoji_url = response.data.results.emoji_url;
                    this.fetch();
                    this.$forceUpdate()
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    $('.modal').modal('hide');
                    that.cropper.destroy();
                });
            } else {
                that.$store.commit("setLoading", false);
                console.error('Error. No image.')
            }

        },

        saveUpdate() {
            const that = this;
            that.$store.commit("setLoading", true);
            if (this.user_update_info.change_avatar && this.user_update_info.change_emoji) {
                this.user_update_info.type = 2;
            } else if (this.user_update_info.change_avatar && !this.user_update_info.change_emoji) {
                this.user_update_info.type = 0;
            } else {
                this.user_update_info.type = 1;
            }
            updateAvatar({
                avatar_id: this.user_update_info.avatar_id == 0 ? -1 : this.user_update_info.avatar_id,
                avatar_img: this.user_update_info.avatar_img,
                emoji_id: this.user_update_info.emoji_id ? this.user_update_info.emoji_id : 0,
                type: this.user_update_info.type,
                extension_file: this.user_update_info.extension_file,
            }).then((response) => {
                that.$store.commit("setLoading", false);
                if (response.data.code != 0) {
                    this.showError(response.data.msg)
                    return;
                }
                that.user_info.avatar_id = response.data.results.avatar_id;
                that.user_info.avatar_url = response.data.results.avatar_url ? response.data.results.avatar_url : "/themes/ito/images/avatar-default-orange.svg";
                that.user_info.emoji_id = response.data.results.emoji_id;
                that.user_info.emoji_url = response.data.results.emoji_url;
                that.user_update_info.avatar_id = response.data.results.avatar_id;
                that.user_update_info.avatar_url = response.data.results.avatar_url ? response.data.results.avatar_url : "/themes/ito/images/avatar-default-orange.svg";
                that.user_update_info.emoji_id = response.data.results.emoji_id;
                that.user_update_info.emoji_url = response.data.results.emoji_url;
                this.user_update_info.change_avatar = undefined
                this.user_update_info.change_emoji = undefined
                this.fetch();
                $('.modal').modal('hide');
                $('#changeAvatarSuccessModal').modal('show');
                this.$forceUpdate()
            }).catch((response) => {
                that.$store.commit("setLoading", false);
                console.error(response)
            });
        },

        showError(error) {
            this.errors = error;
            $('.modal').modal('hide');
            $('#errorModalProfile').modal('show');
        },

        getCustomAvatar() {
            axios.all([getCustomAvatars()]).then(axios.spread((response) => {
                if (response.data.code != 0) {
                    return;
                }
                const objects = response.data.results.objects;
                const current_object = response.data.results.student_object
                this.objects = objects;
                if (objects) {
                    objects.forEach(object => {
                        if (current_object) {
                            var customAvatar = {}
                            current_object.forEach(async (item) => {
                                customAvatar[item.object_id] = {
                                    id: '',
                                    shape_id: item.shape_id,
                                    shape_detail_id: item.shape_detail_id,
                                    object_id: item.object_id,
                                    color_id: item.color_id,
                                    order: item.layer_order,
                                    url: item.image_url,
                                    status: undefined
                                }
                            })
                            this.customAvatar = customAvatar
                            this.curentCustomavatar = current_object
                        } else {
                            if (object.is_required == 1) {
                                if (object.shape_details) {
                                    const shape = object.shape_details[0]
                                    if (shape.status == 'activated') {
                                        this.selectShape(object, shape)
                                    }
                                }
                                else if (object.colors) {
                                    const color = object.colors[0]
                                    const shape = color.shape_details[0]
                                    if (shape.status == 'activated') {
                                        this.selectShape(object, shape)
                                    }
                                }
                            }
                        }
                    })
                }
            }));
        },

        selectShape(category, shape) {
            const vm = this;
            if (shape.status == "activated") {
                if (shape.image_url) {
                    let dataUri = shape.image_url;
                    if (category && shape) {
                        this.$set(this.customAvatar, category.id, {
                            shape_id: shape.shape_id,
                            shape_detail_id: shape.id,
                            object_id: category.id,
                            color_id: shape.color_id,
                            order: category.layer_order,
                            url: dataUri,
                            status: shape.status
                        })
                    }
                    const linked_object = this.objects.find((e) => e.linked_object_id != 0 && e.linked_object_id == category.id) || undefined;
                    var linked_object_color, linked_object_shape;
                    if (linked_object) {
                        if (linked_object.colors) {
                            linked_object_color = linked_object.colors.find((e) => e.id == shape.color_id)
                            linked_object_shape = linked_object_color.shape_details.find((e) => e.shape_id == shape.shape_id)
                        } else if (linked_object.shape_details) {
                            linked_object_shape = linked_object.shape_details.find((e) => e.shape_id == shape.shape_id)
                        }
                        if (linked_object_shape.image_url) {
                            let dataUri = linked_object_shape.image_url;
                            this.$set(this.customAvatar, linked_object.id, {
                                shape_id: linked_object_shape.shape_id,
                                shape_detail_id: linked_object_shape.id,
                                object_id: linked_object.id,
                                color_id: linked_object_shape.color_id,
                                order: linked_object.layer_order,
                                url: dataUri,
                                status: linked_object_shape.status
                            })
                        }
                        else {
                            this.removeShape(linked_object)
                        }
                    }
                }
            }
            this.$forceUpdate()
        },

        removeShape(category) {
            delete this.customAvatar[category.id]
            const linked_object = this.objects.find((e) => e.linked_object_id != 0 && e.linked_object_id == category.id) || undefined;
            if (linked_object) {
                delete this.customAvatar[linked_object.id]
            }
            this.$forceUpdate()
        },

        buyShape(category, shape) {
            if (this.user_info.gem >= shape.price) {
                this.selectedShape = shape
                this.selectedCategory = category
                $('.modal').modal('hide');
                $('#confirmBuyItem').modal('show')
            } else {
                this.showError({ title: 'not_enough_gems', message: 'collect_more_gems' })
            }
        },

        buyItem() {
            const that = this
            that.$store.commit("setLoading", true);
            buyCustomAvatar({
                shape_id: this.selectedShape.shape_id,
            }).then((response) => {
                that.$store.commit("setLoading", false);
                if (response.data.code != 0) {
                    if (response.data.code == 3) {
                        this.showError({ title: 'not_enough_gems', message: 'collect_more_gems' })
                    } else {
                        this.showError({ title: 'has_error', message: response.data.error_code })
                    }
                    return;
                }
                that.getCustomAvatar();
                this.$store.state.user_info.gem -= this.selectedShape.price
                this.selectShape(this.selectedCategory, this.selectedShape)
                $('.modal').modal('hide')
                $('#uploadAvatarModal').modal('show')
            }).catch((response) => {
                that.$store.commit("setLoading", false);
                console.error(response)
            });
        },

        async saveCustomAvatar() {
            const that = this;
            that.$store.commit("setLoading", true);
            const element = document.querySelector('#original')
            // const element = document.querySelector('#customAvatar')
            var formdata = new FormData;
            var customAvatar = Object.values(this.customAvatar)
            var student_object = customAvatar.map((item) => {
                return {
                    shape_id: item.shape_id,
                    shape_detail_id: item.shape_detail_id,
                    object_id: item.object_id,
                    color_id: item.color_id
                }
            })
            domToDataUrl(element, {
                debug: false,
                quality: 1,
                fetch: {
                    requestInit: {
                        cache: 'no-store',
                    }
                }
            }).then(dataUrl => {
                formdata.append('student_object', JSON.stringify(student_object));
                formdata.append('avatar_img', dataUrl);
                formdata.append('extension', 'png');
                saveCustomAvatar(formdata).then((response) => {
                    that.$store.commit("setLoading", false);
                    const data = response.data
                    if (data.code != 0) {
                        this.showError(response.data.msg)
                        return;
                    } else {
                        this.$store.state.user_info.avatar_url = data.results.avatar_url
                        this.user_update_info.avatar_url = data.results.avatar_url
                        this.user_update_info.avatar_id = -1
                        this.fetch();
                        this.$forceUpdate();
                        $('.modal').modal('hide')
                        $('#changeAvatarSuccessModal').modal('show');
                    }

                }).catch((response) => {
                    // that.is_custom_avatar_changed = false;
                    console.error(response)
                });
            })
        },

        isSelectedShape(category, shape) {
            var result = false;
            if (shape === 'no_shape') {
                if (!this.customAvatar[category.id]) {
                    result = true;
                }
            } else {
                var customAvatar = this.customAvatar[category.id]
                if (customAvatar && shape) {
                    if (customAvatar.shape_detail_id == shape.id) {
                        result = true;
                    }
                }
            }
            return result;
        },

        isCurrentShape(category, shape) {
            var result = false;
            if (this.curentCustomavatar.length) {
                var object = this.curentCustomavatar.find(({ object_id }) => object_id === category.id)
                if (object) {
                    if (object.shape_detail_id == shape.id) {
                        result = true;
                    }
                } else {
                    if (shape === 'no_shape') {
                        result = true;
                    }
                }
            }
            return result;
        },

        isCustomavatarEdited() {
            var result = false;
            return result;
        },
    }
}
</script>

<style scoped>
#uploadAvatarModal .modal-dialog {
    max-width: 941px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
}

#uploadAvatarModal .modal-content {
    box-shadow: inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    border-radius: 16px;
}

#uploadAvatarModal .avatar-preview {
    padding: 20px 35px;
    background-color: #ff7800;
    height: 440px;
    flex: 0 0 auto;
    width: 216px;
}

#uploadAvatarModal .avatar-preview .title {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0.02em;
    color: #FFFFFF;
    margin: 0;
    text-align: center;
}

#uploadAvatarModal .avatar-preview .avatar {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

#uploadAvatarModal .avatar-preview .avatar .emoticon {
    background: #FFFFFF;
    box-shadow: 2px 2px 0px rgb(0 0 0 / 7%);
    width: 38px !important;
    height: 38px !important;
    border-radius: 100%;
    position: absolute;
    bottom: -5px;
    right: -5px;
    border: solid 2px #fff;
}

#uploadAvatarModal .avatar-preview .avatar-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 120px;
    height: 120px;
    padding: 0;
    margin: 0 auto;
    border: 4px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 90em;
    box-shadow: none;
    background: #fff;
    overflow: hidden;
}

#customAvatar,
#original {
    position: relative;
    overflow: hidden;
}

#customAvatar img,
#original img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
}

.avatar_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1024px;
    height: 1024px;
}



#uploadAvatarModal .avatar-preview .control {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.avatar-edit {
    width: 725px;
    height: 440px;
    max-height: 440px;
    flex: 0 0 auto;
}

#main-nav {
    border-bottom: 1px solid rgba(42, 57, 86, .2);
    margin: 0 106px 0 30px;
    height: 50px;
}

#main-nav .nav-item .nav-link {
    background-color: #fff;
    padding: 20px 20px 8px 20px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    align-items: center;
    text-align: center;
    color: rgba(42, 57, 86, .5);
    border-top: none;
    border-left: none;
    border-right: none;
    transition: all .3s;
}

#main-nav .nav-item .nav-link:focus,
#main-nav .nav-item .nav-link:hover {
    border-bottom: solid 3px;
}

#main-nav .nav-item .nav-link.active {
    color: #F04B25;
    background-color: #fff;
    border-bottom: solid 3px #F04B25;
}

#main-tab-content {
    width: 100%;
    height: 390px;
    padding: 0 10px 10px 10px;
    overflow-y: auto
}

.avatar-list {
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    gap: 10px;
    margin: 0 20px;
}

.avatar-list .avatar-item {
    position: relative;
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.avatar-list .avatar-item .avatar-item-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 8px;
    background: #F6F6F6;
    border-style: solid;
    border-width: 2px 2px 4px 2px;
    border-color: #DBDBDB;
    transition: all .5s;
    overflow: hidden;
}

.locked {
    position: absolute;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 8px;
    top: 0;
    left: 0;
    background: #0000004a;
    z-index: 1;
}

.locked::after {
    content: url('data:image/svg+xml,<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect width="27" height="27" fill="url(%23pattern0_8471_122551)"/><defs><pattern id="pattern0_8471_122551" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="%23image0_8471_122551" transform="scale(0.00520833)"/></pattern><image id="image0_8471_122551" width="192" height="192" xlink:href="data:image/png;base64,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"/></defs></svg>');
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 27px;
    height: 27px;
}

.avatar-list .avatar-item .avatar-item-wrapper.active,
.avatar-list .avatar-item .avatar-item-wrapper:hover {
    border-color: var(--secondary);
}

.avatar-list .avatar-item .avatar-item-wrapper.current {
    border-color: var(--success);
}

.avatar-list .avatar-item img,
.avatar-list .avatar-item-upload {
    width: 100%;
    height: auto;
    cursor: pointer;
}



#custom-avatar-nav {
    margin: 0 20px;
    border: none;
    gap: 4px;
    padding: 10px 0 5px 0;
    overflow-y: auto;
    position: sticky;
    top: 0;
    background: #FFFFFF;
    z-index: 2;

}

#custom-avatar-nav::-webkit-scrollbar-track {
    visibility: hidden;
}

#custom-avatar-nav::-webkit-scrollbar {
    width: 5px;
}

#custom-avatar-nav::-webkit-scrollbar-thumb {
    visibility: hidden;
}

#custom-avatar-nav:hover::-webkit-scrollbar-track,
#custom-avatar-nav:hover::-webkit-scrollbar-thumb {
    visibility: visible;

}


#custom-avatar-nav .nav-item .nav-link {
    background-color: #fff;
    color: var(--primary);
    border: 1px solid #FF7800;
    border-color: var(--primary);
    border-radius: 60px;
    padding: 4px 10px;
    text-wrap: nowrap;
}

#custom-avatar-nav .nav-item .nav-link.active {
    color: white;
    border-color: white;
    background-color: var(--primary);
}

/* #custom-avatar-tab-content {
    height: calc(100% - 53px);
} */


#colors-nav {
    gap: 12px;
    margin: 0 20px;
    border: none;
    padding: 10px 0;
}

#colors-nav .nav-item .nav-link {
    background-color: #fff;
    color: var(--primary);
    border-width: 2px 2px 4px 2px;
    border-style: solid;
    border-color: #E5E5E5;
    border-radius: 8px;
    padding: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
}

#colors-nav .nav-item .nav-link div {
    width: 31px;
    height: 31px;
    border-radius: 8px;

}

#colors-nav .nav-item .nav-link.active {
    color: white;
    background-color: white;
    border-color: var(--success);
}

/* #colors-tab-content {
    height: calc(100% - 70px);
} */
.modal-title {
    font-size: 16px;
    font-weight: 700;
}

.message {
    font-size: 14px;
    font-weight: 400;
}
</style>